import React, { useEffect, useRef, useState } from "react";
import { DataGrid, GridColDef, GridValueGetterParams } from "@mui/x-data-grid";
import { withSnackbar } from "notistack";
import {
  IconButton,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import {
  Replay as IconReload,
  AddBox as IconAdd,
  Edit as IconEdit,
  Check as IconCheck,
  Close as IconClose,
  PictureAsPdf as IconPdf,
  Article as IconFile,
  ExpandMore as IconExpand,
} from "@mui/icons-material";

import TxtBox from "components/Custom/TxtBox";
import UiDialog from "components/Custom/UiDialog";
import RadioBtn from "components/Custom/RadioBtn";
import Btn from "components/Custom/Btn";
import SwitchBtn from "components/Custom/SwitchBtn";
import AutoComplete from "components/Custom/AutoComplete";
import ConfirmDialog from "components/Custom/ConfirmDialog";
import Loader from "components/Custom/Loader";
import UsersSkeleton from "./UsersSkeleton";
// import {ApiMasters} from '@apihandlers/masters/masters';
import { NOTIFY, DEFAULTS } from "common/config";
import { COLORS } from "common/colors";
import { CONFIRMS, LABELS, SUCCESS, ERRORS, WARNINGS } from "common/lables";

import { COMMON_JS } from "common/scripts";
import { MASTER_APIs } from "apihandlers/master";

import "./styles/gpt.css";

let _timer = null;

const GPT = (props: any) => {
  const [loading, setLoading] = useState(true);

  const [questionId, setQuestionId] = useState(-1);

  const [rows, setRows] = useState<any>([]);

  const [manageDialog, setManageDialog] = useState(false);
  const [selectedRow, setSelectedRow] = useState<any>({});

  useEffect(() => {
    if (loading) {
      getRows();
    }
  }, [loading]);

  const getRows = () => {
    const args = {
      pageNo: 1,
      pageLength: DEFAULTS.PAGE_LENGTH,
    };
    MASTER_APIs.getGptMaster(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        setRows(Object.values(response));
        setLoading(false);
      }
    });
  };

  const onEditRow = (row: any) => {
    setSelectedRow(row);
    setManageDialog(true);
  };

  const manageRecord = () => {
    const question = (
      document.getElementById("question") as HTMLInputElement
    ).value.trim();

    // Validations
    if (!question) {
      COMMON_JS.showNotify(props, NOTIFY.WARNING, WARNINGS.QUESTION_EMPTY);
      return;
    }

    const args = {
      id: selectedRow.id || -1,
      parentId: selectedRow.parentId || -1,
      question,
      sortingOrder: 1,
    };
    MASTER_APIs.manageGptMaster(args).then((res) => {
      if (res.status === 200) {
        COMMON_JS.showNotify(props, NOTIFY.SUCCESS, SUCCESS.RECORD_SUCCESS);
        setSelectedRow({});
        setManageDialog(false);
      } else {
        COMMON_JS.showNotify(props, NOTIFY.ERROR, ERRORS.RECORD_FAILED);
      }
    });
  };

  const Row = (data, children: any) => {
    return (
      <Accordion>
        <AccordionSummary expandIcon={<IconExpand />} className="accordHeader">
          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <h4>{data.title}</h4>
            <div style={{ width: "15%" }}>
              <IconButton
                onClick={() => {
                  setSelectedRow(data);
                  setManageDialog(true);
                }}
              >
                <IconAdd />
              </IconButton>
            </div>
          </div>
        </AccordionSummary>
        <AccordionDetails className="accordDetails">
          {children}
        </AccordionDetails>
      </Accordion>
    );
  };

  const orgRef: any = useRef();
  const userRef: any = useRef();
  const frequencyRef: any = useRef();

  console.log("gpt: ", rows);

  return (
    <React.Fragment>
      <div className="pageInfo">
        <ul className="breadcrumbs">
          <li>{LABELS.HOME}</li>
          <li className="dim">{" / "}</li>
          <li className="active">{LABELS.GPT_MASTER}</li>
        </ul>
        <h4>{LABELS.GPT_MASTER}</h4>
        {/* <p>{SUB_TITLES.USERS}</p> */}
      </div>

      <div
        className="grid"
        style={{
          width: "98%",
          height: "80%",
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-start",
            alignItems: "center",
            height: 30,
          }}
        >
          <h4>{"ADD "}</h4>
          <IconButton
            onClick={() => {
              onEditRow({});
            }}
          >
            <IconAdd />
          </IconButton>
        </div>
        {loading ? (
          <div
            style={{
              height: 250,
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Loader />
          </div>
        ) : (
          <div>
            {rows.map((row: any) => {
              return row.list.map((r: any) => {
                return (
                  <Row
                    key={r.id}
                    id={r.id}
                    parentId={r.parentId}
                    title={r.question}
                  />
                );
              });
            })}
          </div>
        )}
      </div>

      {manageDialog && (
        <UiDialog
          title={
            selectedRow.id
              ? "Edit Question: " + selectedRow.name
              : "Add New Question"
          }
          open={true}
          size={"sm"}
          onClose={() => {
            setManageDialog(false);
          }}
        >
          <div className="formGroup">
            <label>{LABELS.QUESTION}</label>
            <TxtBox
              id={"question"}
              placeholder={LABELS.QUESTION}
              defaultValue={selectedRow.question || ""}
            />
          </div>
          <div
            className="formGroup"
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: 25,
            }}
          >
            <div
              style={{
                width: "45%",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <Btn text={LABELS.SAVE} onClick={manageRecord} />
              <Btn
                text={LABELS.CANCEL}
                bgColor={COLORS.DIM_DARK_GRAY}
                onClick={() => setManageDialog(false)}
              />
            </div>
          </div>
        </UiDialog>
      )}
    </React.Fragment>
  );
};

export default withSnackbar(GPT);
